<template>
    <div class="courseCorrelationInfo mtop20">
        <!-- 选项卡 -->
        <slot name="course_info_tabs"></slot>
        <!-- 讲师简介 -->
        <!-- <div class="course_lecturers_introduce mtop30"> -->
            <!-- 模块标题 -->
            <!-- <slot name="lecturers_introduce_title"></slot> -->
            <!-- 讲师滑块儿 -->
            <!-- <div class="lecturers_swiper_cotent">
                <div class="lecturers_swiper_btn">
                    <slot name="el-icon-arrow-left"></slot>
                </div>
                <div class="lecturers_swiper">
                    <slot name="lecturers_swiper"></slot>
                </div>
                <div class="lecturers_swiper_btn">
                    <slot name="el-icon-arrow-right"></slot>
                </div>
            </div> -->
        <!-- </div> -->
        <!-- 课程介绍 -->
        <div class="course_introduce mtop30" id="course_introduce">
            <!-- 模块标题 -->
            <slot name="course_introduce_title"></slot>
            <!-- 课程简介文字 -->
            <slot name="course_introduce_text"></slot>
        </div>
        <!-- 课程大纲 -->
        <div class="course_chapter mtop20" id="course_chapter">
            <!-- 模块标题 -->
            <slot name="course_chapter_title"></slot>
            <slot name="course_chapter_list"></slot>
        </div>
        <!-- 相关资料 -->
        <div class="course_files mtop20">
            <!-- 模块标题 -->
            <slot name="course_file_title"></slot>
            <slot name="course_file_list"></slot>
        </div>
    </div>
</template>

<script>
export default {
    data(){

        return{

        }
    }
}
</script>


<style>
.course_info_tabs .el-tabs__header{
    margin: 0;
}
.course_info_tabs .el-tabs__item{
    font-size: 16px;
    font-weight: bold;
    color: #000000;
}
.course_info_tabs .el-tabs__item.is-active,.course_info_tabs .el-tabs__item:hover{
    color: #133d93;
}
.course_info_tabs .el-tabs__active-bar{
    background-color: #133d93;
}
</style>

<style lang="less" scoped>
.course_file_download{
    margin: 10px 10px 16px ;
    margin-top: 18px;
    margin-bottom: 30px;
    width: 128px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: 14px;
    color:#a7a7a7;
    border: solid 1px #a7a7a7;
    cursor: pointer;
    border-radius: 4px;
}
.course_file_item_text{
    height: 24px;
    line-height: 24px;
    font-size: 12px;
    color: #818181;
    width: calc(100% - 42px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.course_file_checkImg{
    margin-right: 6px;
}
.course_file_item{
    padding: 0 10px;
    height: 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
}
.course_chapter_duration{
    width: 120px;
    font-size: 12px;
    text-align: right;
    color:#818181;
}
.course_chapter_item_title_text{
    font-size: 14px;
    color: #000;
    height: 36px;
    line-height: 36px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.chapterVideoImg{
    margin-right: 12px;
}
.course_chapter_item_title{
    width: calc(100% - 140px);
    display: flex;
    flex-direction: row;
    align-items: center;
}
.course_chapter_item{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    margin: 6px 0;
    height: 36px;
    cursor: pointer;
    background: #f3f5fb;
    font-family: "微软雅黑";
    color: #3b3b3b;
}
.course_introduce_text{
    padding: 0 10px;
    font-size: 14px;
    line-height: 28px;
    color: #000;
}
.swiper-container{
    height: 200px;
}
.lecturers_swiper{
    width: 1016px;
    height: 200px;
}
.lecturers_swiper_btn{
    width: 26px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    i{
        font-size: 28px;
        font-weight: bold;
        color: #000000;
        cursor: pointer;
    }
    i.disabled{
        color: #ccc;
        cursor: auto;
        pointer-events: none;
    }
}
.lecturers_swiper_cotent{
    display: flex;
    flex-direction: row;
    height: 200px;
}
.course_info_tabs{
    padding-top: 30px;
}
.courseCorrelationInfo{
    padding: 0 16px;
    background-color: rgb( 255, 255, 255 );
    box-shadow: 0px 0px 9px 0px rgba( 40, 40, 40, .5 );
    overflow: hidden;
}
</style>
